import { createSlice } from '@reduxjs/toolkit';

import {
  getUnsubscribeReasons,
  getUnsubscribeReasonsByStudentId,
} from './actions';

const initialState = {
  data: [] as any[],
  currentPage: 1,
  totalPages: null as any,
  perPage: 50,
};

const unsubscribeReasonsSlice = createSlice({
  name: 'unsubscribeReasons',
  initialState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder.addCase(getUnsubscribeReasons.fulfilled, (_: any, action: any) => {
      return action.payload;
    });

    builder.addCase(
      getUnsubscribeReasonsByStudentId.fulfilled,
      (_: any, action: any) => {
        return action.payload;
      },
    );
  },
});

export default unsubscribeReasonsSlice.reducer;
